import { Button } from "antd";
import React, { useCallback } from "react";
import { RiShoppingBagLine } from "react-icons/ri";
import { addHttpToLink, lightenColor } from "../../../../Utils/StayUpToDate/RenderComponent";
import { isInsideWebsiteTemplatePage } from "../../../../Utils/websiteTemplateGuards";
import { TwitterIcon } from "./SocialIconUtils";
import { isHexDark } from "../../../../Utils/HelperFunction/HelperFunction";
import { darkenColor } from "../../../../Screens/DashboardView/StayUpToDate/LandingPageComponents/LinksComponent/Components/hoverUtils";

const getSvgFromEvent = (e: any) => {
  const current = e.currentTarget;
  if (!current) return null;
  if (current.tagName?.toLowerCase() === "svg") return current;
  return current.querySelector?.("svg") || e.target?.closest?.("svg") || null;
};

const setCustomSvgVarFill = (svg: SVGElement, fill: string | null) => {
  const paths = svg.querySelectorAll("path");
  paths.forEach((path: any) => {
    const fillValue = path.getAttribute("fill");
    if (fillValue && fillValue.includes("var(--social-icon-color)")) {
      path.style.fill = fill ?? "";
    }
  });
};

const setAllPathsFill = (svg: SVGElement, fill: string) => {
  const paths = svg.querySelectorAll("path");
  paths.forEach((path: any) => {
    const pathFill = path.getAttribute("fill");
    if (pathFill === "none" || pathFill === "transparent") return;
    (path as SVGPathElement).style.fill = fill;
  });
};

const clearAllPathsFill = (svg: SVGElement) => {
  const paths = svg.querySelectorAll("path");
  paths.forEach((path: any) => {
    if ((path as SVGPathElement).style.fill) {
      (path as SVGPathElement).style.fill = "";
    }
  });
};

const PostInfoShopLink = (props: any) => {
  const {
    shop_link,

    shoppableContent,
    post_id,
    media_url,
    handleShop,
    platform,
    user_id,
    name,
    socialIconColor,
    designTokens
  } = props;

  
    const { templateName, secondaryColor, tertiaryColor, fontFamily, secondaryFontFamily, forthColor } = designTokens ?? {};
  // Don't apply design tokens if template is Default
  const isDefaultTemplate = templateName === "Default";
  const buttonBackground = isDefaultTemplate ? "#000000" : secondaryColor;
  const buttonTextColor = isDefaultTemplate ? "#FFFFFF" : tertiaryColor;
  const iconColor = socialIconColor || "#000";
  // Website template uses ghost CTA CSS (soft tint hover) — don't inject landing solid-fill lock.
  const useTemplateGhostShop = isInsideWebsiteTemplatePage();

  const handleMouseEnter = useCallback((e: any) => {
    const svg = getSvgFromEvent(e);
    if (!svg) return;
    (svg as any).style.color = "#888";
    setCustomSvgVarFill(svg, "#888");
    setAllPathsFill(svg, "#888");
  }, []);

  const handleMouseLeave = useCallback((e: any) => {
    const svg = getSvgFromEvent(e);
    if (!svg) return;
    (svg as any).style.color = iconColor;
    setCustomSvgVarFill(svg, null);
    clearAllPathsFill(svg);
  }, [iconColor]);

  return (
    <>
      {!useTemplateGhostShop ? (
        /* Landing: keep AntD button colors locked across hover/focus/active */
        <style>{`
          .shoppable-btn,
          .shoppable-btn:hover,
          .shoppable-btn:focus,
          .shoppable-btn:active,
          .ant-btn.shoppable-btn,
          .ant-btn.shoppable-btn:hover,
          .ant-btn.shoppable-btn:focus,
          .ant-btn.shoppable-btn:active,
          a .shoppable-btn,
          a .shoppable-btn:hover,
          a:hover .shoppable-btn {
            background-color: ${buttonBackground} !important;
            color: ${buttonTextColor} !important;
            border-color: transparent !important;
            box-shadow: none !important;
            text-shadow: none !important;
            opacity: 1 !important;
            transform: none !important;
            transition: none !important;
          }
        `}</style>
      ) : null}
      {shop_link ? (
        <a
          href={addHttpToLink(shop_link)}
          target="_blank"
          // target={isMobile ? "_self" : "_blank"}
          rel="noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            verticalAlign: "middle",
            lineHeight: "inherit",
            textDecoration: "none",
            outline: "none",
            ...(secondaryFontFamily ? { fontFamily: secondaryFontFamily } : {}),
            border: "none",
          }}
        >
          {shoppableContent === "icon" || shoppableContent === true ? (
            <RiShoppingBagLine
              className="perma-links"
              style={{ 
                color: iconColor, 
                cursor: "pointer" }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={() => {
                handleShop(post_id, media_url, platform, name, user_id);
              }}
            />
          ) : (
            <Button
              className="shoppable-btn"
              style={
                useTemplateGhostShop
                  ? {
                      ...(fontFamily ? { fontFamily } : {}),
                      ...(secondaryFontFamily ? { fontFamily: secondaryFontFamily } : {}),
                    }
                  : {
                      backgroundColor: buttonBackground,
                      color: buttonTextColor,
                      ...(fontFamily ? { fontFamily } : {}),
                      ...(forthColor && {
                        ["--hover-shop-btn-bg" as any]: isHexDark(forthColor)
                          ? lightenColor(forthColor, 20)
                          : darkenColor(forthColor, 10),
                      }),
                      ...(secondaryFontFamily
                        ? { fontFamily: secondaryFontFamily }
                        : {}),
                    }
              }
              onClick={() => {
                handleShop(post_id, media_url, platform, name, user_id);
              }}
            >
              Shop
            </Button>
          )}
        </a>
      ) : (
        ""
      )}
    </>
  );
};

export default PostInfoShopLink;
